import { useEffect, useState } from 'react';

function getStorageValue(key: string, defaultValue: string) {
    const saved = localStorage.getItem(key);
    const initial = saved ?? defaultValue;
    return initial || defaultValue;
}

export const useLocalStorageValue = (key: string, defaultValue: string): string => {
    const [value, setValue] = useState(getStorageValue(key, defaultValue));

    useEffect(() => {
        const listener = () => setValue(localStorage.getItem(key) ?? defaultValue);
        window.addEventListener('storage', listener);
        return () => window.removeEventListener('storage', listener);
    }, []);

    return value;
};

/**
 * Stores the given value to local storage and make it possible
 * to listen to value changes
 */
export const useLocalStorage = (key: string, defaultValue: string): [string, (value: string) => void] => {
    const [value, setValue] = useState(getStorageValue(key, defaultValue) ?? defaultValue);

    useEffect(() => {
        localStorage.setItem(key, value);
        window.dispatchEvent(new Event('storage'));
    }, [key, value]);

    useEffect(() => {
        const listener = () => setValue(localStorage.getItem(key) ?? defaultValue);
        window.addEventListener('storage', listener);
        return () => window.removeEventListener('storage', listener);
    }, []);

    return [value, setValue];
};
